import { CheckIcon, DeleteIcon, InfoIcon, ArchiveIcon, RecIcon } from "@/components/icons";

export const roles = {
	1: "ADVERTISER_COMPANY",
	2: "ADS_AGENCY",
	3: "SCREEN_OWNER",
	4: "MODERATOR",
};

export const mediaTypes = {
	CAMPAIGN_VIDEO: "campaign_video",
	CAMPAIGN_IMAGE: "campaign_image",
	PLACE_IMAGE: "place_image",
};
export const locationSections = ["Main", "Elevator", "Escalator", "Entrance", "Exit"];
export const PAYMENT_METHODS = {
	CARD:"CARD",
	BANK_TRANSFER:"BANK_TRANSFER"
};

export const DEFAULT_COORDS = [41.311081, 69.240562];

// `titleKey` / `descriptionKey` resolve via vue-i18n at the call-site so the
// status header reflects the active locale. Don't add raw English here.
export const campaignStatuses = {
	0: {
		name: "awaiting_payment",
		color: "orange",
		icon: InfoIcon,
		titleKey: "campaignStatusHeader.awaiting_payment.title",
		descriptionKey: "campaignStatusHeader.awaiting_payment.description"
	},
	1: {
		name: "moderation",
		color: "orange",
		icon: RecIcon,
		titleKey: "campaignStatusHeader.moderation.title",
		descriptionKey: "campaignStatusHeader.moderation.description"
	},
	2: {
		name: "active",
		color: "green",
		icon: CheckIcon,
		titleKey: "campaignStatusHeader.active.title",
		descriptionKey: "campaignStatusHeader.active.description"
	},
	3: {
		name: "deleted",
		color: "red",
		icon: DeleteIcon,
		titleKey: "campaignStatusHeader.deleted.title",
		descriptionKey: "campaignStatusHeader.deleted.description"
	},
	4: {
		name: "archived",
		color: "red",
		icon: ArchiveIcon,
		titleKey: "campaignStatusHeader.archived.title",
		descriptionKey: "campaignStatusHeader.archived.description"
	},
};
export const campaignScreensStatuses = {
	1: {
		name: "loading",
		color: "orange",
		icon: RecIcon,
	},
	2: {
		name: "active",
		color: "green",
		icon: CheckIcon,
	},
};
export const screenStatuses: Record<string, { name: string; color: string }> = {
	draft:     { name: "CREATED",   color: "blue-gradient-from" },
	pending:   { name: "BINDED",    color: "orange" },
	active:    { name: "ACTIVE",    color: "green" },
	suspended: { name: "SUSPENDED", color: "red" },
	unbound:   { name: "UNBINDED",  color: "red" },
	rejected:  { name: "CANCELLED", color: "red" },
};

export const NOTIFICATION_STATUS = {
	CREATED: 0,
	READ: 1,
};

export const NOTIFICATION_TYPE = {
	INFO: 0,
	WARNING: 1,
	ERROR: 2,
	SUCCESS: 3,
};
/**
 * Map a v2 notification event_key to the visual variant the
 * NotificationItem component understands (info / warning / error /
 * success). Anything that doesn't have an explicit mapping falls back to
 * `info`. Keep numeric keys 0..3 around for legacy callers (until they
 * stop touching this map).
 */
export const NOTIFICATION_TYPE_MAP: Record<string | number, string> = {
	0: "info",
	1: "warning",
	2: "error",
	3: "success",

	"campaign.created":     "info",
	"campaign.moderated":   "success",
	"campaign.rejected":    "error",
	"campaign.cancelled":   "warning",
	"campaign.completed":   "success",

	"place.moderated":      "success",
	"place.rejected":       "error",

	"screen.moderated":     "success",
	"screen.rejected":      "error",
	"screen.suspended":     "warning",

	"payment.succeeded":    "success",
	"payment.failed":       "error",

	"transfer.paid":        "success",
	"transfer.failed":      "error",
};

// case CREATED = 0; - Awaiting payment
// case PAYED = 1; - Moderation
// case MODERATED = 2; - Active
// case DELETED = 3; - buni kôrsatmisan sanga keremas
// case ARCHIVED = 4; - ARCHIVED
